/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import React from 'react';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import {
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  HelpBlock,
  Button,
  Col,
  Collapse,
} from 'react-bootstrap';
import SearchSelector from '../SearchSelector';
import RichLabel from '../RichLabel';
import styles from './styles/main.scss';

const propTypes = {
  fields: React.PropTypes.array.isRequired,
  onSubmit: React.PropTypes.func.isRequired,
  labelCols: React.PropTypes.number.isRequired,
  controlCols: React.PropTypes.number.isRequired,
  buttonLabel: React.PropTypes.any.isRequired,
  successButtonLabel: React.PropTypes.any,
  errorButtonLabel: React.PropTypes.any,
  submitError: React.PropTypes.any,
  submitStatus: React.PropTypes.string,
  onClearStatus: React.PropTypes.func,
  onChange: React.PropTypes.func,
};

class RichForm extends React.Component {

  constructor(props) {
    super(props);
    const data = {};
    this.props.fields.forEach((f) => {
      if (!_.isNil(f.value)) {
        data[f.id] = f.value;
      }
    });
    this.state = {
      data,
      errors: {},
      submitError: props.submitError,
      submitted: false,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.checkField = this.checkField.bind(this);
    this.inputRefs = {};
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillReceiveProps(nextProps) {
    const { submitStatus, submitError } = this.state;
    if (!_.isEqual(nextProps.submitError, submitError) ||
        !_.isEqual(nextProps.submitStatus, submitStatus)) {
      this.setState({
        submitError: nextProps.submitError,
        submitStatus: nextProps.submitStatus,
      });
    }

    if (nextProps.submitStatus === 'error' && nextProps.submitError) {
      this.setState({
        showErrorTips: true,
      });
    }

    const fids = _.map(this.props.fields, 'id');
    const nextFids = _.map(nextProps.fields, 'id');
    if (!_.isEqual(fids, nextFids)) {
      const data = {};
      nextProps.fields.forEach((f) => {
        if (!_.isNil(f.value)) {
          data[f.id] = f.value;
        }
      });
      this.setState({ data });
    }

    if (!_.isEqual(nextProps.fields, this.props.fields)) {
      this.setState({ fields: nextProps.fields });
    }
  }

  componentWillUpdate() {
    const {
      submitStatus = '',
      showErrorTips = false,
    } = this.state;

    if (submitStatus !== '' && this.statusTimeout) {
      clearTimeout(this.statusTimeout);
    }
    if (showErrorTips && this.tipsTimeout) {
      clearTimeout(this.tipsTimeout);
    }
  }

  componentDidUpdate() {
    const { submitStatus = '', showErrorTips = false } = this.state;
    const { onClearStatus } = this.props;

    if (submitStatus !== '') {
      this.statusTimeout = setTimeout(() => {
        if (this.mounted) {
          this.setState({ submitStatus: '' });
          if (onClearStatus) {
            onClearStatus();
          }
        }
      }, 1500);
    }
    if (showErrorTips) {
      this.tipsTimeout = setTimeout(() => {
        if (this.mounted) {
          this.setState({ showErrorTips: false });
        }
      }, 3000);
    }

    if (this.inputRef) {
      this.inputRef.setSelectionRange(this.cursorPos, this.cursorPos);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  handleSubmit(e) {
    e.preventDefault();

    let valid = true;
    const { errors } = this.state;
    const { fields, onSubmit } = this.props;

    fields.forEach((f) => {
      const result = this.checkField(f);
      valid = valid && result.valid;
      if (!result.valid) {
        errors[f.id] = result.errmsg;
      }
    });

    this.setState({
      errors,
      submitted: true,
    });

    if (valid && onSubmit) {
      onSubmit(this.state.data);
    }
  }

  checkField(field, value) {
    const { data } = this.state;
    if (_.isUndefined(value)) {
      value = data[field.id];
    }
    if (field.validator) {
      return field.validator(value);
    }
    return {
      valid: true,
    };
  }

  handleFieldChange(field, value, e) {
    const { data, errors, submitted } = this.state;

    this.cursorPos = null;
    this.inputRef = null;

    if (field.formatter) {
      data[field.id] = field.formatter(value, data[field.id]);

      // update input cursor position
      if (e) {
        this.cursorPos = e.target.selectionEnd;
        this.inputRef = this.inputRefs[field.id];
        if (value.length === this.cursorPos) {
          this.cursorPos = data[field.id].length;
        }
      }
    } else {
      data[field.id] = value;
    }

    if (field.onChange) {
      field.onChange(data[field.id]);
    }

    if (submitted) {
      const result = this.checkField(field, data[field.id]);
      if (result.valid) {
        errors[field.id] = null;
      } else {
        errors[field.id] = result.errmsg;
      }
    }
    this.setState({
      data,
      errors,
      submitStatus: '',
      showErrorTips: false,
    });

    const { onChange } = this.props;

    if (onChange) {
      onChange(data);
    }
  }

  renderErrorTips(msg) {
    return (
      <div styleName="errortips-wrapper">
        <div styleName="errortips">
          <i className="fa fa-exclamation-circle" />
          {' '}
          {msg}
        </div>
      </div>
    );
  }

  renderField(field) {
    const { data, errors } = this.state;

    let control;
    if (field.type === 'search-selector') {
      control = (
        <div>
          <SearchSelector
            options={field.options}
            placeholder={field.placeholder}
            onChange={value => this.handleFieldChange(field, value)}
          />
        </div>
      );
    } else {
      control = (
        <div styleName="labeled-input">
          <FormControl
            bsClass="aisz-form-control-f"
            placeholder={field.placeholder}
            value={data[field.id] || ''}
            onChange={e => this.handleFieldChange(field, e.target.value, e)}
            inputRef={(ref) => { this.inputRefs[field.id] = ref; }}
          />
          <div styleName="input-label">
            <RichLabel content={field.inputLabel || ''} />
          </div>
        </div>
      );
    }

    let errorTips;
    if (errors[field.id]) {
      errorTips = this.renderErrorTips(errors[field.id]);
    }

    let helpBlock;
    if (field.help) {
      helpBlock = (
        <HelpBlock styleName="field-help">
          <i className="fa fa-info-circle" />
          {' '}
          {field.help}
        </HelpBlock>
      );
    }

    return (
      <FormGroup
        key={field.id}
        validationState={this.state.errors[field.id] ? 'error' : undefined}
      >
        <Col md={field.labelCols}>
          <ControlLabel bsClass="aisz-control-label">
            {field.label}
            {' '}
            {
              field.required &&
              <span className="glyphicon glyphicon-asterisk" />
            }
          </ControlLabel>
        </Col>
        <Col md={field.controlCols}>
          {control}
          {errorTips}
          {helpBlock}
        </Col>
      </FormGroup>
    );
  }

  render() {
    const {
      submitError,
      submitStatus = '',
      showErrorTips = false,
    } = this.state;
    const {
      labelCols,
      controlCols,
      buttonLabel,
      successButtonLabel,
      errorButtonLabel,
    } = this.props;

    let btnLabel = buttonLabel;
    if (submitStatus === 'success') {
      btnLabel = successButtonLabel || buttonLabel;
    } else if (submitStatus === 'error') {
      btnLabel = errorButtonLabel || buttonLabel;
    }

    return (
      <div styleName="rich-form">
        <Form
          horizontal
          onSubmit={e => this.handleSubmit(e)}
        >
          {
            this.props.fields.map((f) => {
              f.labelCols = this.props.labelCols;
              f.controlCols = this.props.controlCols;
              return this.renderField(f);
            })
          }
          <FormGroup>
            <Col
              mdOffset={this.props.labelCols}
              md={this.props.controlCols}
            >
              <div styleName={`submit ${submitStatus}`}>
                <Button
                  bsStyle="aisz-primary"
                  type="submit"
                >
                  <span styleName="btn-label">
                    { btnLabel }
                  </span>
                </Button>
              </div>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col mdOffset={labelCols} md={controlCols}>
              <Collapse in={showErrorTips}>
                <div>
                  <div styleName="errtips">
                    <span className="halflings halflings-exclamation-sign" />
                    {' '}
                    {submitError}
                  </div>
                </div>
              </Collapse>
            </Col>
          </FormGroup>
        </Form>
      </div>
    );
  }
}

RichForm.propTypes = propTypes;

export default connect(
  () => ({}), {},
)(CSSModules(RichForm, styles, { allowMultiple: true }));




// WEBPACK FOOTER //
// ./src/components/RichForm/index.jsx